import { MenuSection, RouteInfo } from "./sidebar.metadata";

export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "dashboard",
    class: "",
    label: "",
    labelClass: "",
    extralink: false,

    submenu: [],
  },
  {
    path: "",
    title: "Mantenimiento",
    icon: "wrench",
    class: "has-arrow",
    label: "",
    labelClass: "",
    extralink: false,

    submenu: [
      {
        path: "/mantenimiento/estructura-empresarial",
        title: "Estructura Empresarial",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/mantenimiento/seteos-empresariales",
        title: "Seteos Empresariales",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/mantenimiento/distribucion-propiedades",
        title: "Distribucion Propiedades",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/mantenimiento/usuario-permisos",
        title: "Usuarios/Permisos",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "",
        title: "Parametros",
        icon: "",
        class: "has-arrow",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [
          {
            path: "/mantenimiento/parametros",
            title: "General",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/mantenimiento/grupos-contables-clientes",
            title: "Grupo Contable Cliente",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/mantenimiento/grupos-contables-proveedores",
            title: "Grupo Contable Proveedores",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/mantenimiento/tipos-comprobante-contable",
            title: "Tipos Comprobante Contable",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/mantenimiento/formas-pago",
            title: "Formas de Pago",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          
          {
            path: "/mantenimiento/niveles-precio",
            title: "Niveles Precio",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/mantenimiento/retenciones",
            title: "Configuraciones retenciones",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
        ],
      },
      {
        path: "/mantenimiento/sas",
        title: "Registros Rucs Especiales",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/mantenimiento/clientes",
        title: "Clientes",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/mantenimiento/proveedores",
        title: "Proveedores",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/mantenimiento/empleados",
        title: "Empleados",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/mantenimiento/copiar-informacion",
        title: "Migrar Informacion",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Inventario/Servicios",
    icon: "inventory",
    class: "has-arrow",
    label: "",
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/inventario-servicios/productos",
        title: "Productos",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        codigoPermiso: "inventario.productos.ver",
        submenu: [],
      },
      {
        path: "",
        title: "Ingresos/Egresos",
        icon: "",
        class: "has-arrow",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [
          {
            path: "/inventario-servicios/toma-inventarios",
            title: "Toma de Inventario",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "inventario.toma_inventario.ver",
            submenu: [],
          },
          {
            path: "/inventario-servicios/historico-transferencias",
            title: "Transferencia entre Bodegas",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "inventario.transferencias.ver",
            submenu: [],
          },  {
            path: "/inventario-servicios/historico-ajustes",
            title: "Ajustes",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "inventario.ajustes.ver",
            submenu: [],
          },
        ],
      },
      {
        path: "",
        title: "Órdenes de Compra",
        icon: "",
        class: "has-arrow",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [
          {
            path: "/ordenes-compra/ingresar-ordenes",
            title: "Ingresar Órdenes",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_pagar.orden_compra.ver",
            submenu: [],
          },
          {
            path: "/ordenes-compra/aprobaciones",
            title: "Aprobaciones",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: [
              "cuentas_por_pagar.orden_compra.aprobacion.listar",
              "cuentas_por_pagar.devolucion_mercaderia.aprobar",
            ],
            submenu: [],
          },
          {
            path: "/ordenes-compra/recepciones",
            title: "Recepciones de Mercadería",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_pagar.recepcion_mercaderia.ver",
            submenu: [],
          },
          {
            path: "/ordenes-compra/devoluciones",
            title: "Devoluciones a Proveedores",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_pagar.devolucion_mercaderia.ver",
            submenu: [],
          },
          {
            path: "/ordenes-compra/cruces-facturas",
            title: "Cruces de Facturas",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_pagar.orden_compra.cruzar_factura",
            submenu: [],
          },
        ],
      },
    ],
  },

  {
    path: "",
    title: "Eventos Sociales",
    icon: "calendar",
    class: "has-arrow",
    label: "",
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/eventoSocial/ingresar-evento",
        title: "Ingresar Eventos",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "",
        title: "Reportes",
        icon: "",
        class: "has-arrow",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [
          {
            path: "/eventoSocial/reportes/eventos",
            title: "Eventos",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/eventoSocial/reportes/eventos-proveedores",
            title: "Eventos por Proveedores",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
        ],
      },
    ]
  },

  {
    path: "",
    title: "Facturacion",
    icon: "receipt",
    class: "has-arrow",
    label: "",
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/facturacionVentas/cotizacion-ventas-historico",
        title: "Cotizaciones",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/facturacionVentas/facturacion-ventas-panel",
        title: "Factura",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/facturacionVentas/facturacion-recurrente",
        title: "Facturación Recurrente",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/facturacionVentas/facturacion-ventas-historico",
        title: "Facturas Emitidas",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/facturacionVentas/descuentos",
        title: "Descuentos",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        codigoPermiso: "facturacion.descuentos.ver",
        submenu: [],
      },

      {
        path: "/facturacionVentas/guias-de-remision-historico",
        title: "Guias de Remision",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "",
        title: "- Reportes",
        icon: "",
        class: "has-arrow",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [
          {
            path: "/reportes/cotizacion-ventas-clientes",
            title: "Cotizaciones",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },    {
            path: "/reportes/facturas-emitidas",
            title: "Facturas Emitidas",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/reportes/facturacion-ventas-clientes",
            title: "Ventas por cliente",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/reportes/facturacion-ventas-clientes-p",
            title: "Ventas por cliente - producto ",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/reportes/facturacion-ventas-productos",
            title: "Ventas por producto ",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/reportes/ventas-vendedor-usuario",
            title: "Ventas por vendedor/usuario",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
        ],
      },
    ],
  },

  {
    path: "",
    title: "Cuentas por Cobrar",
    icon: "cash",
    class: "has-arrow",
    label: "",
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/cuentas-por-cobrar/cuentas-por-cobrar-historico",
        title: "Ingresar cuentas",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        isFacturacion: true,
        submenu: [],
      },
      {
        path: "/cuentas-por-cobrar/abonos-cancelaciones",
        title: "Abonos / Cancelaciones",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/cuentas-por-cobrar/anticipo-clientes",
        title: "Anticipo de clientes",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/cuentas-por-cobrar/creditos-clientes",
        title: "Nota de credito de clientes",
        isFacturacion: true,
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      
      {
        path: "/cuentas-por-cobrar/subida-retenciones-masivas",
        title: "Subida de retenciones masivas",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "",
        title: "Reportes",
        icon: "contabilidad.svg",
        class: "has-arrow",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [
          {
            path: "/reportes/cuentas-por-cobrar",
            title: "Cartera Clientes",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/reportes/cuentas-por-cobrar-resumen",
            title: "Resumen Cuentas por Cobrar",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_cobrar.reportes.resumen.imprimir",
            submenu: [],
          },
          {
            path: "/reportes/anticipo-clientes",
            title: "Anticipo de Clientes",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/reportes/ncredito-clientes",
            title: "Nota de Credito Clientes",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },{  // Fase 2 Migracion item
            path: "/reportes/estado-cuentas-clientes",
            title: "Estado de Cuenta",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },{
            path: "/reportes/cobros-por-fecha",
            title: "Cobros por Fecha",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_cobrar.reportes.cobros_por_fecha.imprimir",
            submenu: [],
          },{
            path: "/reportes/retenciones-recibidas",
            title: "Retenciones Recibidas",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_cobrar.reportes.retenciones_recibidas.imprimir",
            submenu: [],
          },{
            path: "",
            title: "Cuentas a Fecha",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [
              {
                path: "/reportes/cuentas-a-fecha/cuentas-por-cobrar",
                title: "Cuentas x Cobrar",
                icon: "",
                class: "",
                label: "",
                labelClass: "",
                extralink: false,
                submenu: [],
              },
               {
                path: "/reportes/cuentas-a-fecha/notas-de-credito-clientes",
                title: "Notas de credito de Clientes",
                icon: "",
                class: "",
                label: "",
                labelClass: "",
                extralink: false,
                submenu: [],
              },
               {
                path: "/reportes/cuentas-a-fecha/anticipos-clientes",
                title: "Anticipos de Clientes",
                icon: "",
                class: "",
                label: "",
                labelClass: "",
                extralink: false,
                submenu: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "",
    title: "Cuentas por Pagar",
    icon: "pay",
    class: "has-arrow",
    label: "",
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/cuentas-por-pagar/abonos-cancelaciones",
        title: "Ingresar cuentas",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        isFacturacion: true,
        submenu: [],
      },

      {
        path: "/cuentas-por-pagar/pagar-cuenta",
        title: "Abonos / Cancelaciones",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },

      {
        path: "/cuentas-por-pagar/anticipo-proveedores",
        title: "Anticipo de proveedores",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/cuentas-por-pagar/nota-credito-proveedores",
        title: "Nota de credito Proveedores",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      
      {
        path: "/cuentas-por-pagar/subida-facturas-masivas",
        title: "Subida de facturas masivas",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "",
        title: "Reportes",
        icon: "contabilidad.svg",
        class: "has-arrow",
        label: "",
        labelClass: "",
        extralink: false,

        submenu: [
          {
            path: "/reportes/cuentas-por-pagar",
            title: "Cartera de Proveedores",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/reportes/cuentas-por-pagar-resumen",
            title: "Resumen Cuentas por Pagar",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_pagar.reportes.resumen.imprimir",
            submenu: [],
          },
          {
            path: "/reportes/cuentas-por-pagar-ap",
            title: "Anticipo de Proveedores ",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/reportes/cuentas-por-pagar-ncp",
            title: "Nota Credito Proveedores ",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/reportes/cuentas-por-pagar-dr",
            title: "Documentos Recibidos",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },{
            // Fase 2: EStado de cuenta de proveedores migrado, ademas se reemplazo la ruta de /cuentas-por-pagar/cuentas-proveedores -> /reportes/cuentas-proveedores
            path: "/reportes/estado-cuentas-proveedores",
            title: "Estado de cuenta",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },{
            path: "/reportes/pagos-por-fecha",
            title: "Pagos por Fecha",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_pagar.reportes.pagos_por_fecha.imprimir",
            submenu: [],
          },{
            path: "/reportes/retenciones-emitidas",
            title: "Retenciones Emitidas",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            codigoPermiso: "cuentas_por_pagar.reportes.retenciones_emitidas.imprimir",
            submenu: [],
          },{
            path: "",
            title: "Cuentas a Fecha",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [
               {
                path: "/reportes/cuentas-a-fecha/cuentas-por-pagar",
                title: "Cuentas x Pagar",
                icon: "",
                class: "",
                label: "",
                labelClass: "",
                extralink: false,
                submenu: [],
              },{
                path: "/reportes/cuentas-a-fecha/notas-de-credito-proveedores",
                title: "Notas de credito de Proveedores",
                icon: "",
                class: "",
                label: "",
                labelClass: "",
                extralink: false,
                submenu: [],
              },
               {
                path: "/reportes/cuentas-a-fecha/anticipos-proveedores",
                title: "Anticipos de Proveedores",
                icon: "",
                class: "",
                label: "",
                labelClass: "",
                extralink: false,
                submenu: [],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "",
    title: "Bancos",
    icon: "bank",
    class: "has-arrow",
    label: "",
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/bancos/bancos-panel",
        title: "Cuentas Bancarias",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/bancos/depositos-bancarios",
        title: "Depositos Bancarios",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },{
        path: "/bancos/conciliacion-bancaria",
        title: "Conciliacion Bancaria",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "",
        title: "Reportes",
        icon: "contabilidad.svg",
        class: "has-arrow",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [
          {
            path: "/reportes/depositos-bancarios",
            title: "Depositos Bancarios",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    path: "",
    title: "Contabilidad",
    icon: "book",
    class: "has-arrow",
    label: "",
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/contabilidad/plan-cuentas",
        title: "Plan de Cuentas",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/contabilidad/asientos-contables-historico",
        title: "Asientos Contables",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "",
        title: "- Reportes",
        icon: "",
        class: "has-arrow",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [
          {
            path: "/contabilidad/reportes-asientos-contables",
            title: "Asientos Contables",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/contabilidad/reportes-balances",
            title: "Balances",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
          {
            path: "/contabilidad/reportes-estados",
            title: "Estados de Cuenta",
            icon: "",
            class: "",
            label: "",
            labelClass: "",
            extralink: false,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    path: "",
    title: "Impuestos",
    icon: "file-text",
    class: "has-arrow",
    label: "",
    autorizacion: true,
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/impuestos/generacion-ats",
        title: "Generacion de ATS",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Autorizador",
    icon: "shield",
    class: "has-arrow",
    label: "",
    autorizacion :true,
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/autorizador/seteos",
        title: "Seteos",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/autorizador/documentos",
        title: "Autorizador de Documentos",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Permisos / Politicas",
    icon: "shield",
    class: "has-arrow",
    label: "",
    autorizacion: true,
    labelClass: "",
    extralink: false,
    submenu: [
      {
        path: "/seguridad/asignar-roles",
        title: "Asignar Roles",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        codigoPermiso: "authz.usuarios.ver",
        submenu: [],
      },
      {
        path: "/seguridad/roles",
        title: "Roles y Permisos",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        codigoPermiso: "authz.roles.ver",
        submenu: [],
      },
      {
        path: "/seguridad/auditoria",
        title: "Auditoria",
        icon: "",
        class: "",
        label: "",
        labelClass: "",
        extralink: false,
        codigoPermiso: "authz.auditoria.ver",
        submenu: [],
      },
    ],
  },
  // {
  //   path: "",
  //   title: "Bancos",
  //   icon: "bancos.svg",
  //   class: "has-arrow",
  //   label: "",
  //   labelClass: "",
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: "/bancos/bancos-panel",
  //       title: "Cuentas Bancarias",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Contabilidad",
  //   icon: "contabilidad.svg",
  //   class: "has-arrow",
  //   label: "",
  //   labelClass: "",
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: "/contabilidad/plan-cuentas",
  //       title: "Plan de Cuentas",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/contabilidad/asientos-contables-historico",
  //       title: "Asientos Contables",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //   ],
  // },
  // {
  //   path: "",
  //   title: "Reportes",
  //   icon: "contabilidad.svg",
  //   class: "has-arrow",
  //   label: "",
  //   labelClass: "",
  //   extralink: false,

  //   submenu: [{
  //     path: "",
  //     title: "Facturacion",
  //     icon: "",
  //     class: "has-arrow",
  //     label: "",
  //     labelClass: "",
  //     extralink: false,
  //     submenu: [
  //       {
  //         path: "/reportes/facturacion-ventas-clientes",
  //         title: "Ventas por cliente",
  //         icon: "",
  //         class: "",
  //         label: "",
  //         labelClass: "",
  //         extralink: false,
  //         submenu: [],
  //       },
  //       {
  //         path: "/reportes/facturacion-ventas-clientes-p",
  //         title: "Ventas por cliente - producto ",
  //         icon: "",
  //         class: "",
  //         label: "",
  //         labelClass: "",
  //         extralink: false,
  //         submenu: [],
  //       },
  //       {
  //         path: "/reportes/facturacion-ventas-productos",
  //         title: "Ventas por producto ",
  //         icon: "",
  //         class: "",
  //         label: "",
  //         labelClass: "",
  //         extralink: false,
  //         submenu: [],
  //       }
  //     ],
  //   },
  //   {
  //     path: "/reportes/cuentas-por-cobrar",
  //     title: "Cuentas por Cobrar",
  //     icon: "",
  //     class: "",
  //     label: "",
  //     labelClass: "",
  //     extralink: false,
  //     submenu: [],
  //   },
  //   {
  //     path: "/reportes/anticipo-clientes",
  //     title: "Anticipo de Clientes",
  //     icon: "",
  //     class: "",
  //     label: "",
  //     labelClass: "",
  //     extralink: false,
  //     submenu: [],
  //   },
  //   {
  //     path: "/reportes/ncredito-clientes",
  //     title: "Nota de Credito Clientes",
  //     icon: "",
  //     class: "",
  //     label: "",
  //     labelClass: "",
  //     extralink: false,
  //     submenu: [],
  //   },
  //   {
  //     path: "",
  //     title: "Cuentas por Pagar",
  //     icon: "",
  //     class: "has-arrow",
  //     label: "",
  //     labelClass: "",
  //     extralink: false,
  //     submenu: [
  //       {
  //         path: "/reportes/cuentas-por-pagar",
  //         title: "Cartera de Proveedores",
  //         icon: "",
  //         class: "",
  //         label: "",
  //         labelClass: "",
  //         extralink: false,
  //         submenu: [],
  //       },
  //       {
  //         path: "/reportes/cuentas-por-pagar-ap",
  //         title: "Anticipo de Proveedores ",
  //         icon: "",
  //         class: "",
  //         label: "",
  //         labelClass: "",
  //         extralink: false,
  //         submenu: [],
  //       },
  //       {
  //         path: "/reportes/cuentas-por-pagar-ncp",
  //         title: "Nota Credito Proveedores ",
  //         icon: "",
  //         class: "",
  //         label: "",
  //         labelClass: "",
  //         extralink: false,
  //         submenu: [],
  //       },
  //       {
  //         path: "/reportes/cuentas-por-pagar-dr",
  //         title: "Documentos Recibidos",
  //         icon: "",
  //         class: "",
  //         label: "",
  //         labelClass: "",
  //         extralink: false,
  //         submenu: [

  //         ],
  //       }
  //     ],
  //   }

  //   ],
  // },
  // {
  //   path: "",
  //   title: "Component",
  //   icon: "mdi mdi-bullseye",
  //   class: "has-arrow",
  //   label: "",
  //   labelClass: "",
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: "/component/accordion",
  //       title: "Accordion",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/alert",
  //       title: "Alert",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/carousel",
  //       title: "Carousel",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/dropdown",
  //       title: "Dropdown",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/modal",
  //       title: "Modal",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/pagination",
  //       title: "Pagination",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/poptool",
  //       title: "Popover & Tooltip",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/progressbar",
  //       title: "Progressbar",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/rating",
  //       title: "Ratings",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/tabs",
  //       title: "Tabs",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/timepicker",
  //       title: "Timepicker",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/buttons",
  //       title: "Button",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //     {
  //       path: "/component/card",
  //       title: "Card",
  //       icon: "",
  //       class: "",
  //       label: "",
  //       labelClass: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //   ],
  // },
];

const SECTIONS_LAYOUT: { id: string; title: string; titles: string[] }[] = [
  {
    id: "operacion",
    title: "Operación",
    titles: [
      "Dashboard",
      "Mantenimiento",
      "Inventario/Servicios",
      "Eventos Sociales",
    ],
  },
  {
    id: "finanzas",
    title: "Finanzas",
    titles: [
      "Facturacion",
      "Cuentas por Cobrar",
      "Cuentas por Pagar",
      "Bancos",
      "Contabilidad",
      "Impuestos",
    ],
  },
  {
    id: "sistema",
    title: "Sistema",
    titles: ["Autorizador", "Permisos / Politicas"],
  },
];

const findRoute = (title: string): RouteInfo | null =>
  ROUTES.find((r) => r.title === title) || null;

export const MENU_SECTIONS: MenuSection[] = SECTIONS_LAYOUT.map((s) => ({
  id: s.id,
  title: s.title,
  items: s.titles.map(findRoute).filter((r): r is RouteInfo => r !== null),
}));
